export const transformPercentageToInteger = (value: string) => {
  const number = parseFloat(value);
  const integer = Math.floor(number);
  return integer;
};
